import React, { useContext, useMemo } from "react";
import { MenuOutlined } from "@ant-design/icons";
import "./index.css";
import { set } from "dot-prop-immutable";
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from "antd";

export const DragHandle = ({ RowContext }) => {
  const { setActivatorNodeRef, listeners } = useContext(RowContext);
  return (
    <Button
      type="text"
      size="small"
      icon={<MenuOutlined />}
      style={{
        cursor: 'move',
      }}
      ref={setActivatorNodeRef}
      {...listeners}
    />
  );
};

export const getSortableRow = (RowContext) => (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: props['data-row-key'],
  });
  const style = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging
      ? {
        position: 'relative',
        zIndex: 9999,
      }
      : {}),
  };
  const contextValue = useMemo(
    () => ({
      setActivatorNodeRef,
      listeners,
    }),
    [setActivatorNodeRef, listeners],
  );
  return (
    <RowContext.Provider value={contextValue}>
      <tr {...props} ref={setNodeRef} style={style} {...attributes} />
    </RowContext.Provider>
  );
};

export const SortableAntTableParent = ({ children, form, formListId }) => {
  const RowContext = React.createContext({});

  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      const data = form.getFieldValue(formListId) || [];
      const newData = arrayMove(data, active.id - 1, over.id - 1);
      if (typeof formListId === "string") {
        form.setFieldsValue({ [formListId]: newData });
      } else {
        const formValues = form.getFieldValue();
        const newFormValues = set(formValues, formListId.join("."), newData);
        form.setFieldsValue(newFormValues);
      }
    }
  }

  return (
    <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
      <SortableContext
        items={(form.getFieldValue(formListId) || []).map((i, index) => index + 1)}
        strategy={verticalListSortingStrategy}
      >
        {children(RowContext)}
      </SortableContext>
    </DndContext>
  )
}
